import { createFileRoute } from "@tanstack/react-router";
import DeckInstallation from "@/pages/services/DeckInstallation";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { deckInstallationFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/deck-installation")({
  head: () =>
    seo({
      title: "Deck Installation in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Custom deck design & installation in Minneapolis & the Twin Cities. Quality wood and low-maintenance composite decks built for Minnesota seasons. Free estimates: (612) 298-9865.",
      path: "/services/deck-installation",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/roofing" },
          { name: "Deck Installation", path: "/services/deck-installation" },
        ]),
        buildServiceSchema({
          name: "Deck Installation in Minneapolis, MN",
          serviceType: "Deck Installation",
          url: absoluteUrl("/services/deck-installation"),
          description:
            "Custom wood and composite deck design and installation for homes across Minneapolis and the Twin Cities metro, built by a licensed local contractor.",
        }),
        buildFaqPageSchema(deckInstallationFaqs),
      ],
    }),
  component: DeckInstallation,
});
